import { useCourse, useCourseDispatch } from './CourseContext';
import { useState } from 'react';

export default function CoursesModeDetailsCourseInfo() {
    const course = useCourse();
    const dispatch = useCourseDispatch();
    const [showImageModal, setShowImageModal] = useState(false);
    const [editField, setEditField] = useState(null);
    const [editVal, setEditVal] = useState('');

    function handleEdit(field, val) {
        setEditField(field);
        setEditVal(val);
    }

    function handleSave() {
        dispatch({ type: 'UPDATE_COURSE_INFO', propName: editField, propVal: editVal });
        setEditField(null);
    }

    return (
        <div className="mode-details-course-info">
            <div>
                <label>Name:</label>
                {editField === 'name' ? (
                    <span>
                        <input value={editVal} onChange={e => setEditVal(e.target.value)} />
                        <button onClick={handleSave}>Save</button>
                        <button onClick={() => setEditField(null)}>Cancel</button>
                    </span>
                ) : (
                    <span>{course.name} <button onClick={() => handleEdit('name', course.name)}>Edit</button></span>
                )}
            </div>
            <div>
                <label>Location:</label>
                {editField === 'location' ? (
                    <span>
                        <input value={editVal} onChange={e => setEditVal(e.target.value)} />
                        <button onClick={handleSave}>Save</button>
                        <button onClick={() => setEditField(null)}>Cancel</button>
                    </span>
                ) : (
                    <span>{course.location} <button onClick={() => handleEdit('location', course.location)}>Edit</button></span>
                )}
            </div>
            <div>
                <label>Description:</label>
                {editField === 'description' ? (
                    <span>
                        <input value={editVal} onChange={e => setEditVal(e.target.value)} />
                        <button onClick={handleSave}>Save</button>
                        <button onClick={() => setEditField(null)}>Cancel</button>
                    </span>
                ) : (
                    <span>{course.description} <button onClick={() => handleEdit('description', course.description)}>Edit</button></span>
                )}
            </div>
        </div>
    );
}
